module.exports = __webpack_public_path__ + "img/hero_mob.47e383d.webp";